import {
  Box,
  Grid,
  type GridProps,
  HStack,
  Heading,
  VStack,
} from '@chakra-ui/react'
import type { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type PageLayoutProps = {
  /**
   * Show Element before the title, useful for buttons with back navigation
   */
  beforeTitle?: ReactNode
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  contentGap?: number
  maxWidth?: GridProps['maxWidth']
}

export function PageLayout({
  title,
  description,
  beforeTitle,
  action,
  children,
  contentGap = 6,
  maxWidth,
}: Readonly<PropsWithChildren<PageLayoutProps>>) {
  const { t } = useTranslation()

  // If title is a string, translate it
  const translatedTitle = typeof title === 'string' ? t(title) : title

  return (
    <Grid gridTemplateAreas={`"heading" "content"`} gap={4} maxWidth={maxWidth}>
      <Grid gridArea="heading" w="100%" alignItems="center" gap={2}>
        {beforeTitle ? <Box w="100%">{beforeTitle}</Box> : null}

        <Grid gridTemplateAreas={`"heading" "content"`} gap={4} mt={2}>
          <VStack w="100%" alignItems="start" gap={4}>
            <HStack
              gridArea="heading"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
              gap={4}
            >
              <Heading as="h1" size="4xl" m={0}>
                {translatedTitle}
              </Heading>

              <Box>{action}</Box>
            </HStack>
            {description}
          </VStack>

          <VStack
            gridArea="content"
            w="100%"
            alignItems="start"
            gap={contentGap}
          >
            {children}
          </VStack>
        </Grid>
      </Grid>
    </Grid>
  )
}
